export default __webpack_public_path__ + "static/media/swift-logo-only.c5ac5648.png";